module.exports = __webpack_public_path__ + "img/collage-big.aa999492.png";